import { useEffect } from 'react';
import { PlacementTask } from 'enums';
import { messages } from 'i18n';
import { HotjarEvents } from 'utils/hotjar-events';
import useSubmissionFilter from './useSubmissionFilter';
import { SubmissionBoxStorageKeys, SubmissionsViewStorageKeys, SubmissionViewMode } from './utils';

const placementTasks = Object.values(PlacementTask);

const getBasePlacementTaskFiltersList = () =>
  placementTasks.map((task) => ({
    key: task,
    checked: false,
    label: messages.placementProcess.placementTasks[task],
  }));

export function usePlacementTaskFilter({
  mode,
  paginationReset,
}: {
  paginationReset: () => void;
  mode: SubmissionViewMode;
}) {
  const storageKey =
    mode === SubmissionViewMode.General
      ? SubmissionsViewStorageKeys.placementTask
      : SubmissionBoxStorageKeys.placementTask;

  const basePlacementTaskFilters = getBasePlacementTaskFiltersList();

  const placementTaskFilter = useSubmissionFilter({
    baseFiltersList: basePlacementTaskFilters,
    storageKey,
    hotjarEvent: HotjarEvents.SubmissionsPlacementTaskFilter,
    paginationReset,
  });

  // First time the filters are loaded from the local storage, we need to make sure that all the placement task filters are present
  // This is relevant when we add a new task in the code that didn't exist before, thus missing in the local storage
  // By default, the new task filter will be turned off
  useEffect(() => {
    if (placementTaskFilter.filters.length !== basePlacementTaskFilters.length) {
      placementTaskFilter.setFilters((prev) =>
        basePlacementTaskFilters.map((task) => ({
          key: task.key,
          checked: prev.find((localStorageTask) => localStorageTask.key === task.key)?.checked ?? false,
          label: task.label,
        })),
      );
    }
  }, [placementTaskFilter, basePlacementTaskFilters]);

  return placementTaskFilter;
}
